import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'
import i18n from '~/i18n'
import { PLATFORM_IDS } from './platforms'
import { PlatformIcon } from './platformIcons'

export default function ClientPicker({ value, onChange }) {
    const listRef = useRef(null)
    const btnRefs = useRef({})
    const [slider, setSlider] = useState({ width: 0, left: 0 })

    const syncSlider = useCallback(() => {
        const btn = btnRefs.current[value]
        if (!btn) return
        setSlider({ width: btn.offsetWidth, left: btn.offsetLeft })
    }, [value])

    useLayoutEffect(() => {
        syncSlider()
    }, [syncSlider])

    useEffect(() => {
        window.addEventListener('resize', syncSlider)
        return () => window.removeEventListener('resize', syncSlider)
    }, [syncSlider])

    return (
        <div className='mcp-clients'>
            <div className='mcp-clients__label'>{i18n.t('mcp:instructions.clientLabel')}</div>
            <div
                ref={listRef}
                className='mcp-clients__seg'
                role='tablist'
                aria-label={i18n.t('mcp:instructions.clientLabel')}
            >
                <span
                    className='mcp-clients__slider'
                    aria-hidden='true'
                    style={{
                        width: slider.width,
                        transform: `translateX(${slider.left}px)`
                    }}
                />
                {PLATFORM_IDS.map((id) => {
                    const name = i18n.t(`mcp:platforms.${id}.name`)
                    const selected = value === id
                    return (
                        <button
                            key={id}
                            ref={(node) => {
                                btnRefs.current[id] = node
                            }}
                            type='button'
                            role='tab'
                            className='mcp-clients__btn'
                            aria-selected={selected}
                            aria-label={name}
                            title={name}
                            onClick={() => onChange(id)}
                        >
                            <PlatformIcon id={id} />
                        </button>
                    )
                })}
            </div>
        </div>
    )
}
